import { useEffect, useState } from "react";
import axios from "axios";
import { ScrollText, Loader2, CheckCircle2, Ban, AlertTriangle, RefreshCw } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const STATUS = {
  done: { icon: CheckCircle2, cls: "text-emerald-300", label: "Ejecutada" },
  cancelled: { icon: Ban, cls: "text-neutral-500", label: "Cancelada" },
  failed: { icon: AlertTriangle, cls: "text-red-300", label: "Falló" },
};

const fmt = (iso) => {
  try { return new Date(iso).toLocaleString("es-MX", { day: "2-digit", month: "2-digit", year: "2-digit", hour: "2-digit", minute: "2-digit" }); }
  catch { return iso; }
};

export const AssistantAuditPanel = () => {
  const { authHeader } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${API}/admin/assistant/audit?limit=60`, { headers: authHeader() });
      setRows(r.data.entries || []);
    } catch { setRows([]); } finally { setLoading(false); }
  };

  useEffect(() => { load(); /* eslint-disable-next-line react-hooks/exhaustive-deps */ }, []);

  return (
    <div className="flex-1 overflow-y-auto p-3 space-y-2" data-testid="admin-assistant-audit-panel">
      <div className="flex items-center justify-between mb-1">
        <div className="text-[10px] uppercase tracking-widest text-[#d4af37] flex items-center gap-1"><ScrollText className="w-3 h-3" /> Bitácora de cambios (IA)</div>
        <button data-testid="admin-assistant-audit-refresh" onClick={load} className="text-neutral-400 hover:text-white"><RefreshCw className="w-3.5 h-3.5" /></button>
      </div>
      {loading ? (
        <div className="py-8 text-center"><Loader2 className="w-5 h-5 animate-spin text-[#d4af37] mx-auto" /></div>
      ) : rows.length === 0 ? (
        <p className="text-xs text-neutral-500 italic text-center py-8">Aún no hay cambios registrados por el asistente.</p>
      ) : rows.map((r) => {
        const st = STATUS[r.status] || STATUS.done;
        const Icon = st.icon;
        return (
          <div key={r.id} data-testid={`admin-assistant-audit-row-${r.id}`} className="rounded-lg border border-white/10 bg-black/40 px-3 py-2">
            <div className="flex items-center justify-between gap-2 text-[10px] text-neutral-500">
              <span>{fmt(r.at)} · {r.admin_username || "admin"}</span>
              <span className={`flex items-center gap-1 ${st.cls}`}><Icon className="w-3 h-3" /> {st.label}</span>
            </div>
            <div className="text-[12px] text-neutral-100 mt-0.5">{r.summary}</div>
            {r.result && <div className="text-[11px] text-neutral-400 mt-0.5">{r.result}</div>}
            {r.error && <div className="text-[11px] text-red-300 mt-0.5">{r.error}</div>}
          </div>
        );
      })}
    </div>
  );
};

export default AssistantAuditPanel;
